import { User } from "../gateway/User/User";

export class AuthTokenUsecase {
    constructor() {
        this.UserGateway = new User();
    }

    async execute({ authToken = "" } = {}) {
        const payload = this.sanitizeInput({ authToken });
        if (!payload.authToken) return null;
        try {
            const response = await this.UserGateway.authToken(payload.authToken);
            if (response?.name === "Error") throw new Error(response.message);
            return response;
        } catch (error) {
            throw new Error(`${error?.message || "Erro ao autenticar token"}`);
        }
    }

    sanitizeInput({ authToken = "" } = {}) {
        const sanitizedAuthToken = String(authToken).trim();
        return {
            authToken: sanitizedAuthToken
        };
    }
}
